import { types } from 'mobx-state-tree';
import Instructor from './Instructor';

export default types
  .model({
    id: types.number,
    urlKey: types.string,
    title: types.string,
    image: types.maybeNull(
      types.model({
        path: types.maybeNull(types.string),
      })
    ),
    instructors: types.maybeNull(types.array(Instructor)),
    instructorDisplay: types.maybeNull(types.string),
    categories: types.optional(types.array(types.string), []),
    price: types.maybeNull(types.number),
  })
  .views((self) => ({
    get imageUrl() {
      if (!self.image?.path) return '';
      return `https://res.mindbodygreen.com/${self.image.path}`;
    },
  }));
